// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Kgv2_FileParagraphFragment = { __typename?: 'FileParagraph', id: string, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }>, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string } | null } | null };

export type Kgv2_NodeAliasFragment = { __typename?: 'KGV2NodeAlias', id: string, aliasText: string, aliasType: Types.Kgv2NodeAliasAliasType, document?: { __typename?: 'KGV2Document', id: string, document: { __typename?: 'Document', id: string } } | null };

export type Kgv2_DocumentFragment = { __typename?: 'KGV2Document', id: string, ingestionState: Types.Kgv2DocumentIngestionState, processingState: Types.Kgv2DocumentProcessingState, executedOn?: Time | null, instrumentName?: string | null, supersessionKind?: Types.Kgv2DocumentSupersessionKind | null, targetInstrumentDate?: Time | null, targetInstrumentTitle?: string | null, revokesAllPrior?: boolean | null, document: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, displayType: string }, supersededBy?: { __typename?: 'KGV2Document', id: string, document: { __typename?: 'Document', id: string, name: string } } | null, supersedesDocument?: { __typename?: 'KGV2Document', id: string, document: { __typename?: 'Document', id: string, name: string } } | null, modificationsMade: { __typename?: 'KGV2DocumentModificationConnection', edges?: Array<{ __typename?: 'KGV2DocumentModificationEdge', node?: { __typename?: 'KGV2DocumentModification', id: string, kind: Types.Kgv2DocumentModificationKind, targetResolution: Types.Kgv2DocumentModificationTargetResolution, targetDescriptorTitle?: string | null, fromDocument: { __typename?: 'KGV2Document', id: string }, toDocument?: { __typename?: 'KGV2Document', id: string, document: { __typename?: 'Document', id: string, name: string } } | null } | null } | null> | null } };

export type Kgv2_StatementEvidenceFragment = { __typename?: 'KGV2StatementEvidence', id: string, page?: number | null, citation?: string | null, snippet?: string | null, reasoning?: string | null, document: { __typename?: 'Document', id: string }, fileParagraphs?: Array<(
    { __typename?: 'FileParagraph' }
    & Kgv2_FileParagraphFragment
  )> | null };

export type Kgv2_ResolvedEntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type Kgv2_ResolvedClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, lastName: string };

export type Kgv2_ResolvedClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type Kgv2_ResolvedTestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string, kind: Types.TestamentaryEntityKind };

export type Kgv2_AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, createdAt: Time, effectiveDate?: Time | null, legalName?: string | null, jurisdictionStateCode?: string | null, gstStatus?: Types.AiSuggestionEntityGstStatus | null, dpTargetKind?: Types.AiSuggestionDpTargetKind | null, dpDeathEvent?: Types.AiSuggestionDispositiveProvisionDeathEvent | null, subtrustType?: Types.AiSuggestionTestamentaryEntityKind | null, subtrustGstStatus?: Types.AiSuggestionEntityGstStatus | null, onboardingEntity?: { __typename?: 'OnboardingEntitySuggestion', nodeName: string, displayName?: string | null, entityName?: string | null, entityKind?: Types.EntityKind | null } | null, onboardingIndividual?: { __typename?: 'OnboardingIndividualSuggestion', nodeName: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, dateOfBirth?: string | null } | null, onboardingOrganization?: { __typename?: 'OnboardingOrganizationSuggestion', nodeName: string, displayName?: string | null } | null, onboardingTestamentaryEntity?: { __typename?: 'OnboardingTestamentaryEntitySuggestion', nodeName: string, displayName?: string | null, testamentaryEntityKind?: Types.TestamentaryEntityKind | null } | null, onboardedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, onboardedIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, onboardedOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, onboardedTestamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null, asset?: { __typename?: 'AssetSuggestion', assetCategoryID?: string | null, assetTitle?: string | null, assetValue?: string | null, nodeID?: string | null, owningEntityID?: string | null, owningEntityName?: string | null } | null, liability?: { __typename?: 'LiabilitySuggestion', asOfDate?: string | null, debtorEntityID?: string | null, debtorEntityName?: string | null, lenderEntityID?: string | null, lenderEntityName?: string | null, liabilityName?: string | null, nodeID?: string | null, outstandingBalance?: string | null } | null, lifeInsurance?: { __typename?: 'LifeInsuranceSuggestion', cashValueAmount?: string | null, deathBenefitAmount?: string | null, insuranceCarrier?: string | null, insuredPeopleNodeIDs?: Array<string> | null, nodeID?: string | null, owningEntityID?: string | null, owningEntityName?: string | null, policyType?: Types.InsurancePolicyKind | null, termLengthYears?: number | null, insuredClientProfiles?: Array<{ __typename?: 'InsuredClientProfileSuggestion', clientProfileID?: string | null }> | null } | null, dpFirstDeathGrantorClientProfile?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, dpTargetNode?: { __typename?: 'KGV2Node', id: string, namePrimary: string, nodeType: Types.Kgv2NodeNodeType } | null, dpRecipient?: { __typename?: 'DispositiveProvisionRecipientSuggestion', recipientKind?: Types.DispositiveProvisionRecipientKind | null, recipientEntityName?: string | null, recipientOrganizationName?: string | null, dispositionKind?: Types.DispositiveProvisionDispositionKind | null, dispositionOrder?: number | null, distributionAmount?: string | null, distributionPercentage?: string | null, distributionDeathEvent?: string | null, recipientTransferTaxKind?: Types.DispositiveProvisionTransferTaxKind | null, notes?: string | null, summary?: string | null, recipientNameParts?: { __typename?: 'PersonNameParts', firstName: string, lastName: string, middleName: string, suffix: string } | null } | null, trustee?: { __typename?: 'InferredTrusteeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> } | null, successorTrustee?: { __typename?: 'InferredTrusteeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> } | null, beneficiaryV2?: { __typename?: 'InferredBeneficiaryDetailsV2', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.BeneficiaryLevel | null, notes?: string | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null } | null, principal?: { __typename?: 'InferredGrantorDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null } | null, trustAdvisor?: { __typename?: 'InferredTrustAdvisorDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order: Types.TrustAdvisorLevel, roles: Array<Types.TrustAdvisorRoleKind> } | null, subtrustCreatedFrom?: { __typename?: 'InferredSubtrustCreatedFromDetails', displayName?: string | null, type?: Types.SubtrustCreatedFromType | null } | null, subtrustTrustee?: { __typename?: 'InferredTrusteeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> } | null, subtrustSuccessorTrustee?: { __typename?: 'InferredTrusteeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> } | null, subtrustTrustAdvisor?: { __typename?: 'InferredTrustAdvisorDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order: Types.TrustAdvisorLevel, roles: Array<Types.TrustAdvisorRoleKind> } | null, subtrustLifetimeBeneficiary?: { __typename?: 'InferredBeneficiaryDetailsV2', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.BeneficiaryLevel | null, notes?: string | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null } | null, subtrustRemainderBeneficiary?: { __typename?: 'InferredBeneficiaryDetailsV2', firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, organizationName?: string | null, order?: Types.BeneficiaryLevel | null, notes?: string | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null } | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null };

export type Kgv2_NodeFragment = { __typename?: 'KGV2Node', id: string, nodeType: Types.Kgv2NodeNodeType, namePrimary: string, state: Types.Kgv2NodeState, createdSource: Types.Kgv2NodeCreatedSource, aliases: { __typename?: 'KGV2NodeAliasConnection', edges?: Array<{ __typename?: 'KGV2NodeAliasEdge', node?: (
        { __typename?: 'KGV2NodeAlias' }
        & Kgv2_NodeAliasFragment
      ) | null } | null> | null }, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & Kgv2_ResolvedEntityFragment
      ) | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & Kgv2_ResolvedClientProfileFragment
      ) | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: (
        { __typename?: 'ClientOrganization' }
        & Kgv2_ResolvedClientOrganizationFragment
      ) | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & Kgv2_ResolvedTestamentaryEntityFragment
      ) | null } | null> | null }, onboardingSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & Kgv2_AiSuggestionFragment
      ) | null } | null> | null } };

export type Kgv2_StatementFragment = { __typename?: 'KGV2Statement', id: string, predicate: string, polarity: Types.Kgv2StatementPolarity, confidence?: number | null, value?: string | null, fact?: string | null, conditionType?: Types.Kgv2StatementConditionType | null, conditionDescription?: string | null, subject: (
    { __typename?: 'KGV2Node' }
    & Kgv2_NodeFragment
  ), object?: (
    { __typename?: 'KGV2Node' }
    & Kgv2_NodeFragment
  ) | null, document?: { __typename?: 'KGV2Document', id: string, document: { __typename?: 'Document', id: string } } | null, evidence: { __typename?: 'KGV2StatementEvidenceConnection', edges?: Array<{ __typename?: 'KGV2StatementEvidenceEdge', node?: (
        { __typename?: 'KGV2StatementEvidence' }
        & Kgv2_StatementEvidenceFragment
      ) | null } | null> | null }, supersededByStatements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string } | null } | null> | null }, supersedesStatements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string } | null } | null> | null }, aiSuggestions?: Array<(
    { __typename?: 'AISuggestion' }
    & Kgv2_AiSuggestionFragment
  )> | null };

export type FetchHouseholdKgv2QueryVariables = Types.Exact<{
  input: Types.FetchHouseholdKgv2Input;
  statementsWhere?: Types.InputMaybe<Types.Kgv2StatementWhereInput>;
}>;


export type FetchHouseholdKgv2Query = { __typename?: 'Query', fetchHouseholdKGV2?: { __typename?: 'KGV2Graph', id: string, name: string, status: Types.Kgv2GraphStatus, household: { __typename?: 'Household', id: string, documents?: Array<{ __typename?: 'Document', id: string, name: string, type: Types.DocumentType, displayType: string }> | null }, documents: { __typename?: 'KGV2DocumentConnection', edges?: Array<{ __typename?: 'KGV2DocumentEdge', node?: (
          { __typename?: 'KGV2Document' }
          & Kgv2_DocumentFragment
        ) | null } | null> | null }, nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: (
          { __typename?: 'KGV2Node' }
          & Kgv2_NodeFragment
        ) | null } | null> | null }, statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
          { __typename?: 'KGV2Statement' }
          & Kgv2_StatementFragment
        ) | null } | null> | null } } | null };

export type BackfillKgv2MutationVariables = Types.Exact<{
  where: Types.HouseholdWhereInput;
}>;


export type BackfillKgv2Mutation = { __typename?: 'Mutation', backfillKGV2: boolean };

export type LinkDataModelWithKgv2NodeMutationVariables = Types.Exact<{
  input: Types.LinkKgv2NodeToDataModelInput;
}>;


export type LinkDataModelWithKgv2NodeMutation = { __typename?: 'Mutation', linkKGV2NodeToDataModel: (
    { __typename?: 'KGV2Node' }
    & Kgv2_NodeFragment
  ) };

export type LinkSuggestionWithKgv2NodeOrStatementMutationVariables = Types.Exact<{
  input: Types.LinkSuggestionWithKgv2NodeOrStatementInput;
}>;


export type LinkSuggestionWithKgv2NodeOrStatementMutation = { __typename?: 'Mutation', linkSuggestionWithKGV2NodeOrStatement: (
    { __typename?: 'AISuggestion' }
    & Kgv2_AiSuggestionFragment
  ) };

export const Operations = {
  Query: {
    FetchHouseholdKGV2: 'FetchHouseholdKGV2' as const
  },
  Mutation: {
    BackfillKGV2: 'BackfillKGV2' as const,
    LinkDataModelWithKGV2Node: 'LinkDataModelWithKGV2Node' as const,
    LinkSuggestionWithKGV2NodeOrStatement: 'LinkSuggestionWithKGV2NodeOrStatement' as const
  },
  Fragment: {
    KGV2_FileParagraph: 'KGV2_FileParagraph' as const,
    KGV2_NodeAlias: 'KGV2_NodeAlias' as const,
    KGV2_Document: 'KGV2_Document' as const,
    KGV2_StatementEvidence: 'KGV2_StatementEvidence' as const,
    KGV2_ResolvedEntity: 'KGV2_ResolvedEntity' as const,
    KGV2_ResolvedClientProfile: 'KGV2_ResolvedClientProfile' as const,
    KGV2_ResolvedClientOrganization: 'KGV2_ResolvedClientOrganization' as const,
    KGV2_ResolvedTestamentaryEntity: 'KGV2_ResolvedTestamentaryEntity' as const,
    KGV2_AISuggestion: 'KGV2_AISuggestion' as const,
    KGV2_Node: 'KGV2_Node' as const,
    KGV2_Statement: 'KGV2_Statement' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const Kgv2_DocumentFragmentDoc = gql`
    fragment KGV2_Document on KGV2Document {
  id
  ingestionState
  processingState
  executedOn
  instrumentName
  supersessionKind
  targetInstrumentDate
  targetInstrumentTitle
  revokesAllPrior
  document {
    id
    name
    type
    displayType
  }
  supersededBy {
    id
    document {
      id
      name
    }
  }
  supersedesDocument {
    id
    document {
      id
      name
    }
  }
  modificationsMade {
    edges {
      node {
        id
        kind
        targetResolution
        targetDescriptorTitle
        fromDocument {
          id
        }
        toDocument {
          id
          document {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const Kgv2_NodeAliasFragmentDoc = gql`
    fragment KGV2_NodeAlias on KGV2NodeAlias {
  id
  aliasText
  aliasType
  document {
    id
    document {
      id
    }
  }
}
    `;
export const Kgv2_ResolvedEntityFragmentDoc = gql`
    fragment KGV2_ResolvedEntity on Entity {
  id
  kind
  subtype {
    id
    displayName
  }
}
    `;
export const Kgv2_ResolvedClientProfileFragmentDoc = gql`
    fragment KGV2_ResolvedClientProfile on ClientProfile {
  id
  displayName
  firstName
  lastName
}
    `;
export const Kgv2_ResolvedClientOrganizationFragmentDoc = gql`
    fragment KGV2_ResolvedClientOrganization on ClientOrganization {
  id
  name
  kind
}
    `;
export const Kgv2_ResolvedTestamentaryEntityFragmentDoc = gql`
    fragment KGV2_ResolvedTestamentaryEntity on TestamentaryEntity {
  id
  displayName
  kind
}
    `;
export const Kgv2_AiSuggestionFragmentDoc = gql`
    fragment KGV2_AISuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  createdAt
  onboardingEntity {
    nodeName
    displayName
    entityName
    entityKind
  }
  onboardingIndividual {
    nodeName
    firstName
    lastName
    middleName
    suffix
    dateOfBirth
  }
  onboardingOrganization {
    nodeName
    displayName
  }
  onboardingTestamentaryEntity {
    nodeName
    displayName
    testamentaryEntityKind
  }
  onboardedEntity {
    id
    subtype {
      id
      displayName
    }
  }
  onboardedIndividual {
    id
    displayName
  }
  onboardedOrganization {
    id
    name
  }
  onboardedTestamentaryEntity {
    id
    displayName
  }
  effectiveDate
  legalName
  jurisdictionStateCode
  gstStatus
  asset {
    assetCategoryID
    assetTitle
    assetValue
    nodeID
    owningEntityID
    owningEntityName
  }
  liability {
    asOfDate
    debtorEntityID
    debtorEntityName
    lenderEntityID
    lenderEntityName
    liabilityName
    nodeID
    outstandingBalance
  }
  lifeInsurance {
    cashValueAmount
    deathBenefitAmount
    insuranceCarrier
    insuredClientProfiles {
      clientProfileID
    }
    insuredPeopleNodeIDs
    nodeID
    owningEntityID
    owningEntityName
    policyType
    termLengthYears
  }
  dpFirstDeathGrantorClientProfile {
    id
    displayName
  }
  dpTargetKind
  dpTargetNode {
    id
    namePrimary
    nodeType
  }
  dpDeathEvent
  dpRecipient {
    recipientKind
    recipientNameParts {
      firstName
      lastName
      middleName
      suffix
    }
    recipientEntityName
    recipientOrganizationName
    dispositionKind
    dispositionOrder
    distributionAmount
    distributionPercentage
    distributionDeathEvent
    recipientTransferTaxKind
    notes
    summary
  }
  trustee {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    duties
  }
  successorTrustee {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    duties
  }
  beneficiaryV2 {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    notes
    powerOfAppointment
    powerOfAppointmentNotes
  }
  principal {
    firstName
    lastName
    middleName
    suffix
    organizationName
  }
  trustAdvisor {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    roles
  }
  subtrustType
  subtrustGstStatus
  subtrustCreatedFrom {
    displayName
    type
  }
  subtrustTrustee {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    duties
  }
  subtrustSuccessorTrustee {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    duties
  }
  subtrustTrustAdvisor {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    roles
  }
  subtrustLifetimeBeneficiary {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    notes
    powerOfAppointment
    powerOfAppointmentNotes
  }
  subtrustRemainderBeneficiary {
    firstName
    lastName
    middleName
    suffix
    organizationName
    order
    notes
    powerOfAppointment
    powerOfAppointmentNotes
  }
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
}
    ${CommonAiSuggestionEvidenceFragmentDoc}`;
export const Kgv2_NodeFragmentDoc = gql`
    fragment KGV2_Node on KGV2Node {
  id
  nodeType
  namePrimary
  state
  createdSource
  aliases {
    edges {
      node {
        ...KGV2_NodeAlias
      }
    }
  }
  resolvedEntities {
    edges {
      node {
        ...KGV2_ResolvedEntity
      }
    }
  }
  resolvedClientProfiles {
    edges {
      node {
        ...KGV2_ResolvedClientProfile
      }
    }
  }
  resolvedClientOrganizations {
    edges {
      node {
        ...KGV2_ResolvedClientOrganization
      }
    }
  }
  resolvedTestamentaryEntities {
    edges {
      node {
        ...KGV2_ResolvedTestamentaryEntity
      }
    }
  }
  onboardingSuggestions {
    edges {
      node {
        ...KGV2_AISuggestion
      }
    }
  }
}
    ${Kgv2_NodeAliasFragmentDoc}
${Kgv2_ResolvedEntityFragmentDoc}
${Kgv2_ResolvedClientProfileFragmentDoc}
${Kgv2_ResolvedClientOrganizationFragmentDoc}
${Kgv2_ResolvedTestamentaryEntityFragmentDoc}
${Kgv2_AiSuggestionFragmentDoc}`;
export const Kgv2_FileParagraphFragmentDoc = gql`
    fragment KGV2_FileParagraph on FileParagraph {
  id
  boundingRegions {
    PageNumber
    Polygon {
      x
      y
    }
  }
  file {
    id
    pdfDocument {
      id
    }
  }
}
    `;
export const Kgv2_StatementEvidenceFragmentDoc = gql`
    fragment KGV2_StatementEvidence on KGV2StatementEvidence {
  id
  page
  citation
  snippet
  reasoning
  document {
    id
  }
  fileParagraphs {
    ...KGV2_FileParagraph
  }
}
    ${Kgv2_FileParagraphFragmentDoc}`;
export const Kgv2_StatementFragmentDoc = gql`
    fragment KGV2_Statement on KGV2Statement {
  id
  predicate
  polarity
  confidence
  value
  fact
  conditionType
  conditionDescription
  subject {
    ...KGV2_Node
  }
  object {
    ...KGV2_Node
  }
  document {
    id
    document {
      id
    }
  }
  evidence {
    edges {
      node {
        ...KGV2_StatementEvidence
      }
    }
  }
  supersededByStatements {
    edges {
      node {
        id
      }
    }
  }
  supersedesStatements {
    edges {
      node {
        id
      }
    }
  }
  aiSuggestions {
    ...KGV2_AISuggestion
  }
}
    ${Kgv2_NodeFragmentDoc}
${Kgv2_StatementEvidenceFragmentDoc}
${Kgv2_AiSuggestionFragmentDoc}`;
export const FetchHouseholdKgv2Document = gql`
    query FetchHouseholdKGV2($input: FetchHouseholdKGV2Input!, $statementsWhere: KGV2StatementWhereInput) {
  fetchHouseholdKGV2(input: $input) {
    id
    name
    status
    household {
      id
      documents {
        id
        name
        type
        displayType
      }
    }
    documents {
      edges {
        node {
          ...KGV2_Document
        }
      }
    }
    nodes(where: {state: active}) {
      edges {
        node {
          ...KGV2_Node
        }
      }
    }
    statements(where: $statementsWhere) {
      edges {
        node {
          ...KGV2_Statement
        }
      }
    }
  }
}
    ${Kgv2_DocumentFragmentDoc}
${Kgv2_NodeFragmentDoc}
${Kgv2_StatementFragmentDoc}`;

/**
 * __useFetchHouseholdKgv2Query__
 *
 * To run a query within a React component, call `useFetchHouseholdKgv2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchHouseholdKgv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHouseholdKgv2Query({
 *   variables: {
 *      input: // value for 'input'
 *      statementsWhere: // value for 'statementsWhere'
 *   },
 * });
 */
export function useFetchHouseholdKgv2Query(baseOptions: Apollo.QueryHookOptions<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>(FetchHouseholdKgv2Document, withFetchPolicyContext(options));
      }
export function useFetchHouseholdKgv2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>(FetchHouseholdKgv2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchHouseholdKgv2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>(FetchHouseholdKgv2Document, withFetchPolicyContext(options));
        }
export type FetchHouseholdKgv2QueryHookResult = ReturnType<typeof useFetchHouseholdKgv2Query>;
export type FetchHouseholdKgv2LazyQueryHookResult = ReturnType<typeof useFetchHouseholdKgv2LazyQuery>;
export type FetchHouseholdKgv2SuspenseQueryHookResult = ReturnType<typeof useFetchHouseholdKgv2SuspenseQuery>;
export type FetchHouseholdKgv2QueryResult = Apollo.QueryResult<FetchHouseholdKgv2Query, FetchHouseholdKgv2QueryVariables>;
export const BackfillKgv2Document = gql`
    mutation BackfillKGV2($where: HouseholdWhereInput!) {
  backfillKGV2(where: $where)
}
    `;
export type BackfillKgv2MutationFn = Apollo.MutationFunction<BackfillKgv2Mutation, BackfillKgv2MutationVariables>;

/**
 * __useBackfillKgv2Mutation__
 *
 * To run a mutation, you first call `useBackfillKgv2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillKgv2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillKgv2Mutation, { data, loading, error }] = useBackfillKgv2Mutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBackfillKgv2Mutation(baseOptions?: Apollo.MutationHookOptions<BackfillKgv2Mutation, BackfillKgv2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackfillKgv2Mutation, BackfillKgv2MutationVariables>(BackfillKgv2Document, options);
      }
export type BackfillKgv2MutationHookResult = ReturnType<typeof useBackfillKgv2Mutation>;
export type BackfillKgv2MutationResult = Apollo.MutationResult<BackfillKgv2Mutation>;
export type BackfillKgv2MutationOptions = Apollo.BaseMutationOptions<BackfillKgv2Mutation, BackfillKgv2MutationVariables>;
export const LinkDataModelWithKgv2NodeDocument = gql`
    mutation LinkDataModelWithKGV2Node($input: LinkKGV2NodeToDataModelInput!) {
  linkKGV2NodeToDataModel(input: $input) {
    ...KGV2_Node
  }
}
    ${Kgv2_NodeFragmentDoc}`;
export type LinkDataModelWithKgv2NodeMutationFn = Apollo.MutationFunction<LinkDataModelWithKgv2NodeMutation, LinkDataModelWithKgv2NodeMutationVariables>;

/**
 * __useLinkDataModelWithKgv2NodeMutation__
 *
 * To run a mutation, you first call `useLinkDataModelWithKgv2NodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkDataModelWithKgv2NodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkDataModelWithKgv2NodeMutation, { data, loading, error }] = useLinkDataModelWithKgv2NodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkDataModelWithKgv2NodeMutation(baseOptions?: Apollo.MutationHookOptions<LinkDataModelWithKgv2NodeMutation, LinkDataModelWithKgv2NodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkDataModelWithKgv2NodeMutation, LinkDataModelWithKgv2NodeMutationVariables>(LinkDataModelWithKgv2NodeDocument, options);
      }
export type LinkDataModelWithKgv2NodeMutationHookResult = ReturnType<typeof useLinkDataModelWithKgv2NodeMutation>;
export type LinkDataModelWithKgv2NodeMutationResult = Apollo.MutationResult<LinkDataModelWithKgv2NodeMutation>;
export type LinkDataModelWithKgv2NodeMutationOptions = Apollo.BaseMutationOptions<LinkDataModelWithKgv2NodeMutation, LinkDataModelWithKgv2NodeMutationVariables>;
export const LinkSuggestionWithKgv2NodeOrStatementDocument = gql`
    mutation LinkSuggestionWithKGV2NodeOrStatement($input: LinkSuggestionWithKGV2NodeOrStatementInput!) {
  linkSuggestionWithKGV2NodeOrStatement(input: $input) {
    ...KGV2_AISuggestion
  }
}
    ${Kgv2_AiSuggestionFragmentDoc}`;
export type LinkSuggestionWithKgv2NodeOrStatementMutationFn = Apollo.MutationFunction<LinkSuggestionWithKgv2NodeOrStatementMutation, LinkSuggestionWithKgv2NodeOrStatementMutationVariables>;

/**
 * __useLinkSuggestionWithKgv2NodeOrStatementMutation__
 *
 * To run a mutation, you first call `useLinkSuggestionWithKgv2NodeOrStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSuggestionWithKgv2NodeOrStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSuggestionWithKgv2NodeOrStatementMutation, { data, loading, error }] = useLinkSuggestionWithKgv2NodeOrStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkSuggestionWithKgv2NodeOrStatementMutation(baseOptions?: Apollo.MutationHookOptions<LinkSuggestionWithKgv2NodeOrStatementMutation, LinkSuggestionWithKgv2NodeOrStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkSuggestionWithKgv2NodeOrStatementMutation, LinkSuggestionWithKgv2NodeOrStatementMutationVariables>(LinkSuggestionWithKgv2NodeOrStatementDocument, options);
      }
export type LinkSuggestionWithKgv2NodeOrStatementMutationHookResult = ReturnType<typeof useLinkSuggestionWithKgv2NodeOrStatementMutation>;
export type LinkSuggestionWithKgv2NodeOrStatementMutationResult = Apollo.MutationResult<LinkSuggestionWithKgv2NodeOrStatementMutation>;
export type LinkSuggestionWithKgv2NodeOrStatementMutationOptions = Apollo.BaseMutationOptions<LinkSuggestionWithKgv2NodeOrStatementMutation, LinkSuggestionWithKgv2NodeOrStatementMutationVariables>;